import _ButterflyEffectDemo from "./butterfly-effect.gif";
import _ILearnDemo from "./ilearn.gif";

export const ButterflyEffectDemo = _ButterflyEffectDemo;
export const ILearnDemo = _ILearnDemo;
